<template>
  <div
    id="kt_content_container"
    class="d-flex flex-column-fluid align-items-start container-xxl"
  >
    <!--begin::Aside-->

    <!--end::Aside-->
    <!--begin::Post-->
    <div class="content flex-row-fluid" id="kt_content">
      <!--begin::Tables Widget 12-->
      <div class="card mb-5 mb-xl-8">
        <!--begin::Header-->
        <div class="card-header border-0 pt-5" v-if="isLoaded">
          <h3 class="card-title align-items-start flex-column">
            <span class="card-label fw-bolder fs-3 mb-1">Mesajlarım</span>
            <span class="text-muted mt-1 fw-bold fs-7"
              >{{ count }} mesajlaşma</span
            >
          </h3>
        </div>
        <!--end::Header-->
        <!--begin::Body-->
        <div class="card-body py-3" v-if="isLoaded">
          <!--begin::Table container-->
          <div class="table-responsive">
            <!--begin::Table-->
            <table class="table align-middle gs-0 gy-4">
              <!--begin::Table head-->
              <thead>
                <tr class="fw-bolder text-muted bg-light">
                  <th class="ps-4 min-w-300px rounded-start">Kişi</th>
                  <th class="min-w-200px">Tarih</th>
                  <th class="min-w-200px text-end rounded-end"></th>
                </tr>
              </thead>
              <!--end::Table head-->
              <!--begin::Table body-->
              <tbody>
                <tr v-for="(item, index) in inbox" :key="`message-${index}`">
                  <td>
                    <div class="d-flex align-items-center">
                      <div class="symbol symbol-50px me-5">
                        <span class="symbol-label bg-light">
                          <img
                            :src="`https://www.terapikoltugu.app/storage/photos/${item.photo}`"
                            class="h-100 align-self-end"
                            alt=""
                          />
                        </span>
                      </div>
                      <div class="d-flex justify-content-start flex-column">
                        <router-link
                          class="
                            text-dark
                            fw-bolder
                            text-hover-primary
                            mb-1
                            fs-6
                          "
                          :to="{
                            name: 'messageDetail',
                            params: { id: item.id },
                          }"
                          v-slot="{ href, navigate, isActive }"
                        >
                          <a
                            :href="href"
                            :class="{ active: isActive }"
                            @click="navigate"
                          >
                            {{ item.name }}
                          </a>
                        </router-link>
                        <span
                          class="text-muted fw-bold text-muted d-block fs-7"
                          >{{ item.title }}</span
                        >
                      </div>
                    </div>
                  </td>
                  <td>
                    <span class="text-muted fw-bold text-muted d-block fs-7">{{
                      item.date
                    }}</span>
                  </td>
                  <td class="text-end">
                    <router-link
                      class="
                        btn
                        btn-bg-light
                        btn-color-muted
                        btn-active-color-primary
                        btn-sm
                        px-4
                        me-2
                      "
                      :to="{
                        name: 'messageDetail',
                        params: { id: item.id },
                      }"
                      v-slot="{ href, navigate, isActive }"
                    >
                      <a
                        :href="href"
                        :class="{ active: isActive }"
                        @click="navigate"
                      >
                        Görüntüle
                      </a>
                    </router-link>

                    <a
                      v-if="false"
                      href="#"
                      class="
                        btn
                        btn-bg-light
                        btn-color-muted
                        btn-active-color-primary
                        btn-sm
                        px-4
                      "
                      >Sil</a
                    >
                  </td>
                </tr>
              </tbody>
              <!--end::Table body-->
            </table>
            <!--end::Table-->
          </div>
          <!--end::Table container-->
        </div>
        <!--begin::Body-->
      </div>
      <!--end::Tables Widget 12-->
    </div>
    <!--end::Post-->
  </div>
</template>

<script>
import * as API from "@/services/";
import { makeDate } from "@/helpers";
export default {
  data() {
    return {
      isLoaded: false,
      token: this.$store.getters.getAccessToken,
      count: null,
      inbox: [],
    };
  },
  created() {
    this.getInbox();
  },
  methods: {
    getInbox: async function () {
      let vm = this;

      let response = await API.getInbox(vm.token);
      vm.inbox = response.data.map((item) => {
        let obj = {};

        obj.id = item.id;
        obj.title = item.title;
        obj.photo = item.photo;
        obj.name = `${item.name} ${item.surname}`;
        obj.date = item.updated_at ? makeDate(item.updated_at) : "-";

        return obj;
      });

      vm.count = response.data.length;
      vm.isLoaded = true;
    },
  },
};
</script>